<template>
  <section class="find-blood-section">
    <h2>ต้องการใช้เลือด?</h2>
    <container>
      <div class="col-sm-12 col-md-4 offset-md-4 mt-3">
        <router-link :to="{ name: 'findBlood'}" class="btn btn-clear btn-lg btn-block">ค้นหาถุงเลือดในระบบ</router-link>
      </div>
    </container>
  </section>
</template>

<script>
import Container from '@/components/Container.vue'

export default {
  name: 'FindBloodSection',
  components: {
    Container
  }
}
</script>

<style scoped lang="scss">
.find-blood-section {
  background-color: $gray-100;
  padding: 2rem 0;
  h2 {
    text-align: center;
    font-size: $h3-font-size;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .find-blood-section {
    h2 {
      font-size: $h1-font-size;
    }
  }
}
</style>
